import React, { ChangeEvent, FunctionComponent, KeyboardEvent, useCallback } from 'react'

import { InputWrapper, InputWrapperProps, TextInput } from '../atoms'
import { formatPartialLicencePlate } from '../extensions'

export type VehicleRegistrationFormat = {
  divider: string
  regex: string
  regexBlacklist?: string
  regexFormat: string[]
  regexIncomplete: string
}

export interface VehicleRegistrationInputProps
  extends Omit<InputWrapperProps, 'onChange' | 'onSubmit'> {
  disabled?: boolean
  value?: string
  onChange: (value: string) => void
  onSubmit?: (value?: string) => void
  placeholder?: string
  format: VehicleRegistrationFormat
}

export const VehicleRegistrationInput: FunctionComponent<
  VehicleRegistrationInputProps
> = ({ disabled, value, onChange, placeholder, onSubmit, name, format, ...props }) => {
  const onInputChange = useCallback(
    ({ target }: ChangeEvent<HTMLInputElement>) => {
      onChange(formatPartialLicencePlate(format)(target.value))
    },
    [onChange],
  )

  const onInputKeyPress = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === 'Enter') {
        event?.preventDefault?.()
        onSubmit?.(value)
      }
    },
    [value, onSubmit],
  )

  return (
    <InputWrapper {...props}>
      <TextInput
        name={name}
        disabled={disabled}
        placeholder={placeholder}
        value={value ?? ''}
        onChange={onInputChange}
        onKeyDown={onInputKeyPress}
        variant='ghost'
        fontFamily='licencePlate'
        width={1}
        typoSize='md'
      />
      {props.children}
    </InputWrapper>
  )
}
